export default {
  CODE: 'code',
  GROUP: 'group',
} as const;
